import { useCallback, useEffect, useState } from 'react';
export function useHash() {
    const [_hash, _setHash] = useState(() => {
        if (typeof window === 'undefined') {
            return '';
        }
        return window.location.hash;
    });
    const setHash = useCallback((newHash) => {
        window.history.pushState(null, '', `${window.location.pathname}${window.location.search}${newHash ? `#${newHash}` : ''}`);
        window.dispatchEvent(new HashChangeEvent('hashchange'));
    }, []);
    useEffect(() => {
        const hashChangeHandler = () => {
            _setHash(window.location.hash);
        };
        window.addEventListener('hashchange', hashChangeHandler);
        return () => window.removeEventListener('hashchange', hashChangeHandler);
    }, []);
    return [_hash, setHash];
}
export function getHashParamValue(param) {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    return hash.get(param);
}
export function useHashParam(param, defaultValue) {
    const [value, setValue] = useState(() => {
        var _a;
        if (typeof window === 'undefined') {
            return defaultValue;
        }
        return (_a = getHashParamValue(param)) !== null && _a !== void 0 ? _a : defaultValue;
    });
    useEffect(() => {
        const hashChangeHandler = () => {
            var _a;
            setValue((_a = getHashParamValue(param)) !== null && _a !== void 0 ? _a : defaultValue);
        };
        window.addEventListener('hashchange', hashChangeHandler);
        return () => window.removeEventListener('hashchange', hashChangeHandler);
    }, [param]);
    const setHashParam = useCallback((newValue) => {
        const hash = new URLSearchParams(window.location.hash.slice(1));
        if (!newValue) {
            hash.delete(param);
            if (!hash.size) {
                window.history.replaceState(null, '', window.location.pathname + window.location.search);
                setValue(undefined);
                return;
            }
            window.location.hash = hash.toString();
            setValue(undefined);
            return;
        }
        hash.set(param, newValue);
        window.location.hash = hash.toString();
    }, [param]);
    return [value, setHashParam];
}
